import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'Home',
        component: () => import('./views/HomePage.vue')
    },
    {
        path:'/about',
        name:'AboutUs',
        component:()=>import('./views/AboutUsPage.vue')
    },
    {
        path:'/privacystatement',
        name:'Privacystatement', 
        component:()=>import('./views/PrivacystatementPage.vue')   
    },
    {
        path:'/uploadavatar',
        name:'UploadAvator',
        component:()=>import('./views/UploadAvator.vue')
    },
    {
        path:'/regist',
        name:'Regist',
        component:()=>import('./views/RegistPage.vue')
    },
    {
        path:'/login',
        name:'Login',
        component:()=>import('./views/LoginPage.vue')
    },
    {
        path:'/getbackpwd',
        name:'GetBackPwd',
        component:()=>import('./views/GetBackPwdPage.vue')
    },
    {
        path:'/resetpwd',
        name:'ResetPwd',
        component:()=>import('./views/ResetPwdPage.vue')
    },
    {
        path:'/modifyuserinfo',
        name:'ModifyUserInfo',
        component:()=>import('./views/ModifyUserInfoPage.vue')
    },
    {
        path:'/mysource',
        name:'MySource',
        component:()=>import('./views/MySourcePage.vue')
    },
    {
        path:'/myorders',
        name:'MyOrders',
        component:()=>import('./views/MyOrdersPage.vue')
    },
    {
        path:'/myorderinfo/:orderguid',
        name:'MyOrderInfo',
        component: () => import('./views/MyOrderInfoPage.vue')
    },
    {
        path: '/myinvoices',
        name: 'MyInvoices',
        component: () => import('./views/MyInvoicePage.vue')
    },
    {
        path: '/myinvoiceinfo/:invoicereqguid?/:orders?',
        name: 'MyInvoiceInfo',
        component: () => import('./views/MyInvoiceInfoPage.vue')
    },
    {
        path: '/proceinvoicereq',
        name: 'ProceInvoiceReq',
        component: () => import('./views/ProceInvoiceReq.vue')
    },
    {
        path: '/proceinvoiceinfo/:invoicereqguid?',
        name: 'ProceInvoiceInfo',
        component: () => import('./views/ProceInvoiceInfoPage.vue')
    },
    {
        path: '/help',
        name: 'Help',
        component: () => import('./views/HelpPage.vue')
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;